import { ReportingControllerBaseConfig } from '../../../../base';
import { SnippetInputLabelController } from './snippetLabelInterface';
import { SnippetInputLabelViewProps } from './snippetLabelProps';

export function createSnippetInputLabelController(
    config: ReportingControllerBaseConfig
): SnippetInputLabelController {
    return {
        useProps(context, item, props): SnippetInputLabelViewProps {
            return {
                content: item.snippet.content,
                button: {
                    onClick: props.disclosure.onOpen,
                },
            };
        },
    };
}
